import script from "./TimelineLoader.vue?vue&type=script&setup=true&lang=ts"
export * from "./TimelineLoader.vue?vue&type=script&setup=true&lang=ts"

import "./TimelineLoader.vue?vue&type=style&index=0&id=136711fe&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-136711fe"]])

export default __exports__